import { ReflectionPupilTypeEnum } from './reflection-pupil-type-enum'

export interface GuardianInterface {
  /**
   * 姓名
   */
  name: string
  /**
   * 手机号
   */
  phone?: string | null
  /**
   * 关系
   */
  pupilTypeLabel: string
  /**
   * 家长类型
   */
  pupilType?: ReflectionPupilTypeEnum | null
  fields: object
  guardianLevel: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class Guardian implements GuardianInterface {
  /**
   * 姓名
   */
  name: string
  /**
   * 手机号
   */
  phone?: string | null
  /**
   * 关系
   */
  pupilTypeLabel: string
  /**
   * 家长类型
   */
  pupilType?: ReflectionPupilTypeEnum | null
  fields: object
  guardianLevel: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: GuardianInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      phone: _phone,
      pupilTypeLabel: _pupilTypeLabel,
      pupilType: _pupilType,
      fields: _fields,
      guardianLevel: _guardianLevel,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.phone = _phone
    this.pupilTypeLabel = _pupilTypeLabel
    this.pupilType = _pupilType
    this.fields = _fields
    this.guardianLevel = _guardianLevel
    this.id = _id
    this.schoolId = _schoolId
  }
}
